import { useQuery } from '@tanstack/vue-query'

import { getPropertyOwnerList } from '../propertyOwnersEndpoints'
import { ownersQueryKeys } from '../propertyOwnersQueryKeys'
import { PROPERTY_OWNER_STATUS } from '../../constants/propertyOwnerStatus'
import type { GetPropertyOwnerListParams } from '../../types/propertyOwnerTypes'

// Rejected property-owners count for the sidebar badge. Reuses the directory
// list endpoint with the rejected status filter (same as the Rejected
// container) and reads its `total`. limit:1 keeps the payload tiny.
const REJECTED_COUNT_PARAMS: GetPropertyOwnerListParams = {
  propertyOwnerStatus: PROPERTY_OWNER_STATUS.REJECTED,
  page: 1,
  limit: 1,
}

export function usePropertyOwnerRejectedCountQuery() {
  return useQuery({
    queryKey: ownersQueryKeys.list(REJECTED_COUNT_PARAMS),
    queryFn: () => getPropertyOwnerList(REJECTED_COUNT_PARAMS),
    select: (res) => res.total,
  })
}
